export const UPDATE_AUTH = (state, auth) => {
  state.auth = auth
}

export const UPDATE_SHOWCART = (state, showCart) => {
  state.showCart = showCart
}

export const UPDATE_BILLING_STATE = (state, billing) => {
  state.auth.user.current_subscription_status = billing.current_subscription_status
  state.auth.user.is_trial = billing.is_trial
  state.auth.user.trial_ends_at = billing.trial_ends_at
}

export const UPDATE_USER = (state, user) => {
  state.auth.user = user
}

export const APPNAV_SEARCH = (state, searchData) => {
  state.appnav = searchData
}

export const UPDATE_ACCOUNT = (state, account) => {
  state.auth.user.account_id = account
}

/**
 * Clear each property, one by one, so reactivity still works.
 *
 * (ie. clear out state.auth.isLoggedIn so Navbar component automatically reacts to logged out state,
 * and the Navbar menu adjusts accordingly)
 *
 * TODO: use a common import of default state to reset these values with.
 */
export const CLEAR_ALL_DATA = (state) => {
    // Auth
  state.auth.isLoggedIn = false
  state.auth.accessToken = null
  state.auth.refreshToken = null
  state.auth.user = null
  state.auth.requestValidationSend = false
  state.auth.register_state = false

    // User
}

export const showNotify = (state, { title, text, type }) => {
  state.notify.show = true
  state.notify.title = title
  state.notify.text = text
  state.notify.type = type
}

export const disableNotify = (state) => {
  state.notify.show = false
}

export const requestValidationSend = (state, value) => {
  state.phoneValidation.requestValidationSend = value
}

export const validatePhoneNumber = (state, value) => {
  state.phoneValidation.phoneValid = value
}

export const updatePhoneNumberList = (state, phoneNumbers) => {
  state.phoneNumbers = phoneNumbers
}

export const getAccountVipTemplate = (state, template) => {
  state.vip_template = template[0]
}

export const getAccountVipIcons = (state, vipIcons) => {
  state.vipIcons = vipIcons
}

export const getPromotionSlug = (state, slug) => {
  state.slug = slug
}

export const updateAccountVipTemplate = (state, template) => {
  state.vip_template[template.item] = template.value
}

export const updateUser = (state, template) => {
  state.auth.user[template.item] = template.value
}
export const updateAccount = (state, template) => {
  state.auth.user.account_id[template.item] = template.value
}
export const setVipKeywords = (state, keywords) => {
  state.vipKeywords = keywords
}
export const getPromotions = (state, promotion) => {
  state.promotions = promotion.promotions
  state.availablePromos = promotion.availablePromos
}
export const getCampaigns = (state, campaigns) => {
  state.campaigns = campaigns
}
export const getPermanentCampaigns = (state, permanentCampaigns) => {
  state.permanentCampaigns = permanentCampaigns
}
export const updatePermanentCampaigns = (state, permanentCampaigns) => {
  state.permanentCampaigns[permanentCampaigns.type][permanentCampaigns.item] = permanentCampaigns.value
}
export const getStaff = (state, staff) => {
  state.staff = staff
}
export const getPromotion = (state, promotion) => {
  state.promotion = promotion
}
export const getDashboard = (state, dashboard) => {
  state.todayLeads = dashboard.todayLeads
  state.weekLeads = dashboard.weekLeads
  state.overAll = dashboard.overAll
  state.outgoing = dashboard.outgoing
  state.incoming = dashboard.incoming
  state.ncv_value = dashboard.ncv_value
}
export const getCreditStatus = (state, credit, monthlyUsed) => {
  state.credit = credit
  state.monthlyUsed = monthlyUsed
}
export const getViralCampaign = (state, viralCampaign) => {
  state.viralCampaign = viralCampaign
}
export const updateViralCampaign = (state, viralCampaign) => {
  state.viralCampaign[viralCampaign.type][viralCampaign.item] = viralCampaign.value
}
export const getViralPermanent = (state, viralPermanent) => {
  state.viralPermanent = viralPermanent
}
export const updateViralPermanent = (state, viralPermanent) => {
  state.viralPermanent[viralPermanent.type][viralPermanent.item] = viralPermanent.value
}
export const getCart = (state, cart) => {
  state.cart = cart
}
export const getAccountNotifications = (state, accountNotifications) => {
  state.accountNotifications = accountNotifications
}
export const setRegisterState = (state, value) => {
  state.auth.register_state = value
}



// WEBPACK FOOTER //
// ./src/store/mutations.js